function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.75,
  y: 1.75,
  width: 18.5,
  height: 18.5,
  rx: 4.25,
  stroke: "#4A5155",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.636 10.9642L20.2326 0.396011C20.5563 0.12331 20.9713 -0.0174962 21.3946 0.00174026C21.8179 0.0209767 22.2183 0.198839 22.5158 0.499769C22.8132 0.800699 22.9859 1.20252 22.9992 1.62491C23.0125 2.04729 22.8654 2.45912 22.5874 2.77805L10.8134 14.5205C10.499 14.8278 10.0763 15 9.636 15C9.19573 15 8.77301 14.8278 8.4586 14.5205L3.4126 9.48801C3.1346 9.16908 2.98754 8.75725 3.00083 8.33487C3.01411 7.91248 3.18675 7.51066 3.48424 7.20973C3.78173 6.9088 4.18215 6.73094 4.60544 6.7117C5.02873 6.69246 5.4437 6.83327 5.7674 7.10597L9.636 10.9642Z",
  fill: "#253036"
});

var SvgIconChecked = function SvgIconChecked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-checked.21935520.svg";
export { ForwardRef as ReactComponent };